export default function (context, {value, field}) {
    let data = {};
    switch (field) {
        case 'Name':
            data = {
                Name: value.toUpFirstLetter(),
                NameLat: value.toUpFirstLetter().toTranslit(),
            };
            break;
        case 'FirstName':
            data = {
                FirstName: value.toUpFirstLetter(),
                FirstNameLat: value.toUpFirstLetter().toTranslit(),
            };
            break;
        case 'MiddleName':
            data = {
                MiddleName: value.toUpFirstLetter(),
                MiddleNameLat: value.toUpFirstLetter().toTranslit(),
            };
            break;
        case 'PassportDate':
            let passportDate = '';
            if (value) {
                let a = value.toDate();
                if (a) {
                    a.setFullYear(a.getFullYear() + context.rootState.user.setting.items.ForeignPassportDurationYears);
                    passportDate = a.toStringRu();
                }
            }
            data = {
                PassportDate: value,
                PassportDateEnd: passportDate,
            };
            break;
        case 'mobile':
            let s = '';
            let r = '';
            let n = '';
            if (value.indexOf('380') === 0||value.indexOf('375') === 0) {
                s = '380';
                r = value.slice(3,5);
                n = value.slice(5,value.length);
            }
            if (value.indexOf('7') === 0) {
                s = '7';
                r = value.slice(1, 4);
                n = value.slice(4, value.length);
            }
            if(!s){
                s = value.slice(0, 1);
                r = value.slice(1, 4);
                n = value.slice(4, value.length);
            }
            data = {
                mobile: value,
                Mobile_CC: s,
                Mobile_RG: r,
                Mobile_Number: n,
            };
            break;
        default:
            data[field] = value;
    }
    context.commit('set', data);
}